document.addEventListener('DOMContentLoaded', function() {
    const audioWrapper = document.querySelector('.podcast-audio');
    
    if (!audioWrapper) { return; }
    
    const audio = document.getElementById('audio');
    const audioBtn = document.getElementById('audioBtn');
    const playIcon = audioBtn.querySelector('.icon-play');
    const pauseIcon = audioBtn.querySelector('.icon-pause');
    const progressContainer = document.querySelector('.time-progress'); 
    const progressBar = document.getElementById('audioProgress'); 

    // Hide progress bar initially
    if (progressContainer) { progressContainer.classList.add('d-none'); }

    function updateButtonState(isPlaying) {
        if (isPlaying) {
            playIcon.classList.add('d-none');
            pauseIcon.classList.remove('d-none');
            if (progressContainer) { progressContainer.classList.remove('d-none'); }
            audioWrapper.classList.add('playing');

        } else {
            playIcon.classList.remove('d-none');
            pauseIcon.classList.add('d-none');
            audioWrapper.classList.remove('playing');
        }
    }

    // Handle audio button click
    if (audioBtn && audio) {
        audioBtn.addEventListener('click', function() {
            if (audio.paused) {
                audio.play();
            } else {
                audio.pause();
            }
        });
    }

    const urlParams = new URLSearchParams(window.location.search);
    const shouldAutoplay = urlParams.get('autoplay') === '1';

    // INITIAL UI STATE
    if (!shouldAutoplay) {
        playIcon.classList.remove('d-none');
        pauseIcon.classList.add('d-none');
        progressContainer.classList.add('d-none');
        audioBtn.style.opacity = '1';
    }

    // Autoplay
    if (audio && shouldAutoplay) {
        const playPromise = audio.play();
        if (playPromise !== undefined) {
            playPromise.then(() => {
                updateButtonState(true);
            }).catch(() => {});
        }
    }

    // Sync button state
    if (audio && audioBtn) {

        audio.addEventListener('play', function() {
            updateButtonState(true);
        });

        audio.addEventListener('pause', function() {
            updateButtonState(false);
        });

        audio.addEventListener('ended', function() {
            playIcon.classList.remove('d-none');
            pauseIcon.classList.add('d-none');
            progressContainer.classList.add('d-none');
            progressBar.style.width = '0%';
            audioBtn.style.opacity = '1';
            audioWrapper.classList.remove('playing');
        });

        audio.addEventListener('timeupdate', function() {
            if (progressBar && audio.duration) {
                const percent = (audio.currentTime / audio.duration) * 100;
                progressBar.style.width = percent + '%';
            }
        });

        if (progressContainer) {
            progressContainer.addEventListener('click', function(e) {
                const rect = progressContainer.getBoundingClientRect();
                const offsetX = e.clientX - rect.left;
                const width = rect.width;
                const newTime = (offsetX / width) * audio.duration;
                audio.currentTime = newTime;
            });
        }
    }
});

// audio time display
document.addEventListener('DOMContentLoaded', function () {
    const audio = document.getElementById('audio');

    if (!audio) { return; }
    const currentTimeEl = document.getElementById('currentTime');
    const totalDurationEl = document.getElementById('totalDuration');

    // Format seconds → MM:SS
    function formatTime(seconds) {
        const mins = Math.floor(seconds / 60);
        const secs = Math.floor(seconds % 60);
        return (
            String(mins).padStart(2, '0') +
            ":" +
            String(secs).padStart(2, '0')
        );
    }

    // Show total duration once metadata is loaded
    audio.addEventListener('loadedmetadata', function () {
        totalDurationEl.textContent = formatTime(audio.duration);
    });

    // Update running time while playing
    audio.addEventListener('timeupdate', function () {
        currentTimeEl.textContent = formatTime(audio.currentTime);
    });
});

// Podcast audio subtitles/captions
document.addEventListener('DOMContentLoaded', function () {
    const audio = document.getElementById('audio');
    const captionEl = document.getElementById('audioCaption');

    if (!audio || !captionEl) { return; }

    const HAS_CAPTION_CLASS = 'has-caption';

    function getActiveLanguage() {
        const urlParams = new URLSearchParams(window.location.search);
        const langParam = urlParams.get('lang');
        if (langParam) {
            return langParam.toLowerCase();
        }

        const match = /(?:^|;\s*)diversability_lang=([^;]+)/.exec(document.cookie);
        if (match?.[1]) {
            return decodeURIComponent(match[1]).toLowerCase();
        }

        if (window.dvTranslation?.currentLang) {
            return String(window.dvTranslation.currentLang).toLowerCase();
        }
        return 'en';
    }

    function isTrackMatch(trackLang, targetLang) {
        if (trackLang === targetLang) {
            return true;
        }
        return targetLang === 'zh' && (trackLang === 'zh' || trackLang === 'zh-cn');
    }

    function getActiveTrack() {
        if (!audio.textTracks?.length) {
            return null;
        }
        const targetLang = getActiveLanguage();
        let matched = null;
        let defaultTrack = null;

        for (const track of audio.textTracks) {
            const trackLang = (track.language || '').toLowerCase();
            if (isTrackMatch(trackLang, targetLang)) {
                matched = track;
            }
            if (trackLang === 'en') {
                defaultTrack = track;
            }
        }
        return matched || defaultTrack || audio.textTracks[0];
    }

    function enableTracks() {
        const activeTrack = getActiveTrack();
        if (!activeTrack) {
            return;
        }

        for (const track of audio.textTracks) {
            if (track === activeTrack) {
                track.mode = 'hidden';
            } else {
                track.mode = 'disabled';
            }
        }
    }

    function updateCaption() {
        const activeTrack = getActiveTrack();
        if (!activeTrack) {
            captionEl.textContent = '';
            captionEl.classList.remove(HAS_CAPTION_CLASS);
            return;
        }

        if (activeTrack.mode === 'disabled') {
            activeTrack.mode = 'hidden';
        }

        const cues = activeTrack.activeCues;
        if (cues && cues.length > 0) {
            const texts = [];
            for (const cue of cues) {
                if (cue.text) {
                    texts.push(cue.text);
                }
            }
            if (texts.length > 0) {
                captionEl.textContent = texts.join(' ');
                captionEl.classList.add(HAS_CAPTION_CLASS);
                return;
            }
        }
        captionEl.textContent = '';
        captionEl.classList.remove(HAS_CAPTION_CLASS);
    }

    if (audio.textTracks && audio.textTracks.length > 0) {
        enableTracks();
        for (const track of audio.textTracks) {
            track.addEventListener('cuechange', updateCaption);
        }
    }

    audio.addEventListener('loadedmetadata', function () {
        enableTracks();
        for (const track of audio.textTracks) {
            track.addEventListener('cuechange', updateCaption);
        }
    });

    audio.addEventListener('timeupdate', updateCaption);

    audio.addEventListener('ended', function () {
        captionEl.textContent = '';
        captionEl.classList.remove(HAS_CAPTION_CLASS);
    });

    const trackElements = audio.querySelectorAll('track');
    trackElements.forEach(function (trackEl) {
        trackEl.addEventListener('load', function () {
            enableTracks();
            updateCaption();
        });
    });
});
